export default __webpack_public_path__ + "static/media/Swiss721BTRegular.8f71e5fe.woff";